
import { UK_ROUTES_NEW } from "constants/routes-new";

import Layout from "components/basic/Layout";
import Navigation from "components/basic/Navigation/Navigation";
import SignUpSection from "components/common/SignUpSection";

import HeroCall from "./components/HeroCall";
import PriceTables from "./components/PriceTables";

const PricesPage = () => {
    return (
        <div className="prices-page">
            <Layout>
                <Navigation items={[{
                    title: "Home",
                    url: UK_ROUTES_NEW.home,
                }, {
                    title: "Pricing",
                    url: UK_ROUTES_NEW.pricing,
                }]} />
                <div className="section-title">
                    <HeroCall />
                </div>
                <div className="horizontal-center w100">
                    <PriceTables />
                </div>
                <div>
                    <SignUpSection />
                </div>
            </Layout>
        </div>
    );
};

export default PricesPage;
